export enum QueryReportType {
  Feature = "feature",
  Bug = "bug",
  ResourceRequest = "resourcerequest"
}
